const config = {
  aws_project_region: 'us-east-2',
  aws_cognito_region: 'us-east-2',
  aws_user_pools_id: 'us-east-2_jnayvZydd',
  aws_user_pools_web_client_id: '4o66brqabr4in15gl9i0i5fmra',
  aws_cognito_identity_pool_id: 'us-east-2:a889d407-74fc-48a1-a4a4-c1b01128de97',
  Auth: {
    Cognito: {
      userPoolId: 'us-east-2_jnayvZydd',
      userPoolClientId: '4o66brqabr4in15gl9i0i5fmra',
      identityPoolId: 'us-east-2:a889d407-74fc-48a1-a4a4-c1b01128de97',
      region: 'us-east-2'
    }
  },
  environment: 'prod',
  aws_cognito_signin_uri: 'https://smartestatedocs.com/',
  aws_cognito_signout_uri: 'https://smartestatedocs.com/',
  aws_cloud_logic_custom: [
    {
      name: 'DocCreationAPI',
      endpoint: 'https://xg5e7udwse.execute-api.us-east-2.amazonaws.com',
      region: 'us-east-2'
    },
    {
      name: 'AIDraftingAPI',
      endpoint: 'https://pt6eqpswmk.execute-api.us-east-2.amazonaws.com',
      region: 'us-east-2'
    }
  ],
  bedrock_agents: {
    docCreation: {
      agentId: 'G6DBKER8BQ',
      agentAliasId: 'NSUZY4JOO0',
      region: 'us-east-2'
    },
    aiDrafting: {
      agentId: 'MNDHV7IACN',
      agentAliasId: 'VHQFWRDBXA',
      region: 'us-east-2'
    }
  }
};

const getEnvironmentConfig = () => config;

export default getEnvironmentConfig;
